<template>
  <section class="explore">
    <div class="container">
      <SectionTitle>
        {{ $t("conference.explore.title") }}
      </SectionTitle>

      <div class="explore-content">
        <div class="explore-content__column">
          <div class="explore-content__column-text">
            <h3>
              {{ $t("conference.explore.subtitle1") }}
            </h3>
            <p>
              {{ $t("conference.explore.text1") }}
            </p>
          </div>
        </div>
        <div class="explore-content__column">
          <div class="explore-content__column-text">
            <h3>
              {{ $t("conference.explore.subtitle2") }}
            </h3>
            <p>
              {{ $t("conference.explore.text2") }}
            </p>
          </div>
          <BaseButton class="button" to="#program">{{
            $t("conference.explore.button")
          }}</BaseButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from "@/components/common/BaseButton.vue";
import SectionTitle from "@/components/common/SectionTitle.vue";

export default {
  name: "ExploreSection",
  components: {
    BaseButton,
    SectionTitle,
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  /* gap: 64px; */
  gap: clamp(2rem, 1.1485rem + 3.1683vw, 4rem);
}
.explore-content {
  max-width: 977px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* gap: 5rem; */
  gap: clamp(2rem, 0.7228rem + 4.7525vw, 5rem);
}
.explore-content__column {
  width: calc(50% - 40px);
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (max-width: 768px) {
  .explore-content__column {
    width: 100%;
  }
}

.explore-content__column-text {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

h3 {
  /* font-size: 1.75rem; */
  font-size: clamp(1.375rem, 1.2153rem + 0.5941vw, 1.75rem);
  line-height: 1.5;
  font-weight: 700;
  font-family: "Helvetica Neue", Arial, Helvetica, sans-serif;
}
h3 + p {
  /* font-size: 1rem; */
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
}

.button {
  position: relative;
}

/* @media screen and (min-width: 1400px) {
  .button::after {
    content: "";
    margin-left: 0.5rem;
    position: absolute;
    right: -210px;
    top: 1.5rem;
    background-image: url("../../assets/images/conference/explore-arrow.svg");
    background-repeat: no-repeat;
    width: 281px;
    height: 283px;
    pointer-events: none;
  }
} */
</style>
